export default "/images/df32da0e76f256f596222d94a1d56229.avif";